import { BaseController } from "./BaseController";

export class InvalidController extends BaseController {
  readonly is_invalid_controller = true;
}